var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    PropertyModificationBrickModel: function (opts) {
        /*
            block: block,
            editor: blockPropertyEditorPopup,
            form: form
         */
        
        var editor = opts.editor
            , form = editor.find('form')
            , actionSelector = form.find('[name="Action"]');

        Operator.Layout.setupCollections(form);

        var updateFormForCurrentSelectedAction = function(){
            var selectedAction = actionSelector.val()
                , activeActionContainer = form.find('[data-collection-container-for^="' + selectedAction + '"]')
                , disabledActionContainers = form.find('[data-collection-container-for]:not([data-collection-container-for^="' + selectedAction + '"])');

            //Display our 'active' container
            activeActionContainer.show();

            //Hide all unused containers
            disabledActionContainers.hide();
            
            //Ensure our add button is wired to the correct container
            editor.find('.add-collection-editor')
                .data('collection-property', activeActionContainer.data('collectionContainerFor'));
        }
        
        actionSelector.on('change', updateFormForCurrentSelectedAction);

        //Represent the initial state
        updateFormForCurrentSelectedAction();
    }
});